/**
 * This class calls tealium with channel data if the row is 50% in viewport
 */

export default class TealTrack {
  constructor () {
    this.viewport = document.querySelector('section[data-name="viewport"]')
    this.elements = document.querySelectorAll('section[data-name][data-layout-name]:not([data-name="inactivityDialog"]):not([data-name="viewport"])')
    this.observerOptions = {
      rootMargin: '0px',
      threshold: 0.5
    }

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target) {
          this.getTeaserData(entry.target)

          observer.unobserve(entry.target)
        }
      })
    }, this.observerOptions)

    if (this.viewport) {
      this.observer.observe(this.viewport)
    }

    if (this.elements.length) {
      this.elements.forEach((element) => {
        this.observer.observe(element)
      })
    }
  }

  /**
   * Gather data from the given channel row
   * @param {HTMLCollection} element - The HTML for the channel row
   */
  getTeaserData (element) {
    const gatheredInfo = {
      teasersInfo: {
        ...(element.hasAttribute('data-name') && { teaserBlockName: element.getAttribute('data-name') }),
        ...(element.hasAttribute('data-tracking-name') && { teaserBlockLayout: element.getAttribute('data-tracking-name') }),
        ...(element.hasAttribute('data-block-number') && { teaserBlockPosition: element.getAttribute('data-block-number') })
      },
      businessEventType: 'expose',
      ...window.utag_data
    }
    let teaserNumber = 1

    const extractTeaserInfo = (child) => {
      let objectData = {}
      let bannerID = ''

      if (child.hasAttribute('data-service-slot')) {
        if (child.querySelector('[campaignid][bannerid]')) {
          bannerID = child.querySelector('[campaignid][bannerid]').getAttribute('bannerid')
        }

        if (child.querySelector('[data-component="teaser"]')) {
          child = child.querySelector('[data-component="teaser"]')
        }

        objectData = this.gatherAttributes(child, true, teaserNumber, bannerID)

        gatheredInfo.teasersInfo.teaserBlockItems.push(objectData)

        teaserNumber += 1
      } else if (child.getAttribute('data-component') === 'teaser') {
        objectData = this.gatherAttributes(child, false, teaserNumber, bannerID)

        gatheredInfo.teasersInfo.teaserBlockItems.push(objectData)

        teaserNumber += 1
      } else if (child.querySelectorAll('[data-component="teaser"]').length > 0) {
        child.querySelectorAll('[data-component="teaser"]').forEach((innerChild) => {
          if (getComputedStyle(innerChild).display !== 'none') {
            const isAdSlot = innerChild.hasAttribute('data-service-slot')

            objectData = this.gatherAttributes(innerChild, isAdSlot, teaserNumber, bannerID)

            gatheredInfo.teasersInfo.teaserBlockItems.push(objectData)

            teaserNumber += 1
          }
        })
      }
    }

    if (element.getAttribute('data-name') !== 'viewport' && element.children.length) {
      if (element.hasAttribute('data-tr-component-path')) {
        let elementPos = (Array.from(element.parentElement.children).filter(child => child.offsetHeight > 0)).findIndex(el => el === element)

        if (window.PageConfig.site === 'll') {
          elementPos = Array.from(element.parentElement.parentElement.children).findIndex(el => el === element.parentElement)
        }
        gatheredInfo.componentPath = element.getAttribute('data-tr-component-path') + '.' + elementPos
      }

      gatheredInfo.teasersInfo.teaserBlockItems = [];

      [...element.children].forEach((child) => {
        if (getComputedStyle(child).display !== 'none') {
          extractTeaserInfo(child)
        }
      })
      this.sendData(gatheredInfo)

    } else if (element.getAttribute('data-name') === 'viewport') {
      [...element.children].forEach((child) => {
        gatheredInfo.teasersInfo.teaserBlockItems = []

        if (getComputedStyle(child).display !== 'none') {
          extractTeaserInfo(child)

          gatheredInfo.componentPath = child.getAttribute('data-tr-component-path') + '.' + (Array.from(child.parentElement.children).filter(eleChild => eleChild.offsetHeight > 0)).findIndex(el => el === child)
          this.sendData(gatheredInfo)
        }
      })
    }
  }

  /**
   * Gather Attributes of each teaser and adslot
   * @param {HTMLElement} child - teaser or adslot of the current channel row
   * @param {Boolean} isAdSlot - true if an adslot is recognised
   * @param {number} teaserNumber - current teaser number of the channel row
   * @param {String} bannerID - if an adslot is given, it contains a campaign id attribute which will serve as value for articleId
   */
  gatherAttributes (child, isAdSlot, teaserNumber, bannerID) {
    return {
      teaserItemPosition: teaserNumber,
      ...(isAdSlot ? { teaserItemSource: 'adserve' } : { teaserItemSource: 'cms' }),
      ...(child.hasAttribute('data-teaser-id') && !bannerID && { articleId: 'cmd:' + child.getAttribute('data-teaser-id') }),
      ...(bannerID && { articleId: 'ad:' + bannerID }),
      ...(child.hasAttribute('data-headline') && { teaserItemHeadline: child.getAttribute('data-headline') }),
      ...(child.hasAttribute('data-ab-test-id') && child.hasAttribute('data-ab-name') && {
        teaserItemTestId: child.getAttribute('data-ab-test-id'), teaserItemVariant: child.getAttribute('data-ab-name')
      })
    }
  }

  /**
   * Send gathered data to tealium
   * @param {Object} teasersInfo - The gathered object teaser data of the channel row
   */
  sendData (teasersInfo) {
    window.utag?.link(teasersInfo)
  }
}
